import { css } from '@emotion/react';
import styled from '@emotion/styled';

import type { EllipsisWrapperProps } from './types';

const EllipsisWrapper = (props: EllipsisWrapperProps) => {
  const { className, enable, children } = props;

  if (!enable) return children;

  return (
    <EllipsisWrapperRoot className={className} ownerState={props}>
      {children}
    </EllipsisWrapperRoot>
  );
};

export default EllipsisWrapper;

const EllipsisWrapperRoot = styled('span', {
  shouldForwardProp: prop => !['ownerState'].includes(prop as string),
})<{ ownerState: EllipsisWrapperProps }>(
  ({ ownerState }) => css`
    display: ${ownerState.textVariant === 'inline' ? 'inline-block' : 'block'};
    width: ${ownerState.width};
    max-width: ${ownerState.maxWidth};
    min-width: 0;
  `,
);
